import { useLingui } from "@lingui/react";
import { useMemo } from "react";
const cities = require("./cities.json");

/**
 * B = Brussels Hoofdstedelijk Gewest
 * W = Waals Gewest
 * V = Vlaams Gewest, (Flanders)
 */
export type Gewest = "B" | "W" | "V";
interface City {
  name: {
    nl: string;
    fr: string;
  };
  taxRate: number;
  gewest: Gewest;
}

export const useCity = (postalCode: string) => {
  const {
    i18n: { locale },
  } = useLingui();

  const city = cities[postalCode] as City;

  return useMemo(() => {
    if (!city) {
      return;
    }
    return {
      taxRate: city.taxRate,
      name: city.name[locale as "nl" | "fr"],
      gewest: city.gewest,
    };
  }, [city, locale]);
};
